import React from "react";
import styled from "styled-components";

import Player, { PlayerContextType } from "js/react/views/Player/Player";

const PlayerContainer = styled.div`
    overflow: hidden;
    width: 100vw;
    height: 100vh;
    position: relative;
    background: black;
`;

class PlayerWrapper extends React.Component {
    render() {
        return (
            <PlayerContainer>
                <Player contextType={PlayerContextType.APP} />
            </PlayerContainer>
        );
    }
}

export default PlayerWrapper;
